import { render, staticRenderFns } from "./RelatedJewels.vue?vue&type=template&id=5164531b&scoped=true&"
import script from "./RelatedJewels.vue?vue&type=script&lang=js&"
export * from "./RelatedJewels.vue?vue&type=script&lang=js&"
import style0 from "./RelatedJewels.vue?vue&type=style&index=0&id=5164531b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5164531b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5164531b')) {
      api.createRecord('5164531b', component.options)
    } else {
      api.reload('5164531b', component.options)
    }
    module.hot.accept("./RelatedJewels.vue?vue&type=template&id=5164531b&scoped=true&", function () {
      api.rerender('5164531b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RelatedJewels.vue"
export default component.exports